(function($){

	$(document).ready(function(){

		if($('.hero-slider__wrapper').length) {

			$('.hero-slider__wrapper').each(function(e) {

				if(!$(this).hasClass('slick-initialized')) {

					$prevArrow = $(this).siblings('.hero-slider__navigation-container').find('.prev-arrow');
					$nextArrow = $(this).siblings('.hero-slider__navigation-container').find('.next-arrow');

					$(this).on('init afterChange', function(e, slick){
						currentSlick = $('.slick-current.slick-active', slick.$slideTrack);
					  	currentSlickIndex = String(slick.currentSlide + 1).padStart(2, '0');
					  	currentSlickCount = '/' + String(slick.slideCount).padStart(2, '0');

					  	$(this).siblings('.hero-slider__navigation-container').find('.nav-labels .nav-current').text(currentSlickIndex);
					  	$(this).siblings('.hero-slider__navigation-container').find('.nav-labels .nav-total').text(currentSlickCount);

					  	nextTitle = currentSlick.next().data('title');

				  		if(nextTitle != '' && $(window).width() > 768) {
				  			$(this).siblings('.hero-slider__navigation-container').find('.hero-slider__navigation').css('width','380px').css('padding','11px 11px 20px 20px');
				  			$(this).siblings('.hero-slider__navigation-container').find('.next-story-title').html(nextTitle);	
				  			$(this).siblings('.hero-slider__navigation-container').find('.next-label, .next-story-title').show();
				  		} else {
				  			$(this).siblings('.hero-slider__navigation-container').find('.next-label, .next-story-title').hide();
				  			$(this).siblings('.hero-slider__navigation-container').find('.hero-slider__navigation').css('width','135px').css('padding','11px');
				  		}
						
						$(this).siblings('.hero-slider__navigation-container').css('opacity', 1);
					}).on('beforeChange', function(e, slick) {
						$(this).siblings('.hero-slider__navigation-container').css('opacity', 0);
					}).slick({
				        slidesToShow: 1,
			        	slidesToScroll: 1,
			        	arrows: true,
			        	dots: false,
			        	infinite: true,
			        	autoplay: true,
			        	pauseOnFocus: false,
			        	pauseOnHover: false,
						// cssEase: 'ease-in-out',
						speed: 800,
						autoplaySpeed: 9000,
						prevArrow: $prevArrow,
						nextArrow: $nextArrow
				    })
				}

			});			
		}

	});
	
})(jQuery);